import clsx from 'clsx';
import React from 'react';

import FlexLink from '@components/FlexLink';
import { subscriber_profile_path } from '@routes';
import { User } from '@utils/backend-api/currentUser';

export default function UserProfileLink({
  user,
  className,
  linkClassName,
  children,
}: {
  user: Pick<User, 'name' | 'username' | 'profile_enabled'>;
  className?: string;
  linkClassName?: string;
  children: React.ReactNode;
}) {
  // TODO: Should link be disabled if user doesn't have an active/paying account?

  if (user.profile_enabled) {
    return (
      <FlexLink
        href={subscriber_profile_path(user.username)}
        className={clsx(className, linkClassName)}
        toRailsPage
      >
        {children}
      </FlexLink>
    );
  }

  return <span className={className}>{children}</span>;
}
